import { useEffect } from 'react';

import { useRouteContext } from '../RouteProvider';

interface Props {
  to: string;
  params?: Record<string, string>;
  replace?: boolean;
  state?: Record<string, unknown>;
}

export default function Redirect(props: Props) {
  const { navigate, generatePath } = useRouteContext();

  useEffect(() => {
    const path = generatePath(props.to, props.params);
    navigate(path, { replace: props.replace, state: props.state });
  }, []);

  return null;
}
